// @sinslav this empty answer needs for text question to stabilize answer schema
// look for https://github.com/erikras/redux-form/issues/879
export default { value: '' };
